// these are defined in the on pardot in the form handler
export const formFields = {
  email: 'email',
  first_name: 'first_name',
  last_name: 'last_name',
  company: 'company',
  build_tool: 'build_tool',
  pain_points: 'pain_points',
} as const;

// The caseing here needs to match the caseing in the pardot form handler
export const painPointOptions = [
  { label: 'Build Speed', value: 'Build Speed' },
  { label: 'Dependency Issues', value: 'Dependency Issues' },
  { label: 'Debugging Builds', value: 'Debugging Builds' },
  { label: 'Build Reliability', value: 'Build Reliability' },
  { label: 'Flaky Tests', value: 'Flaky Tests' },
  { label: 'Other', value: 'Other' },
];

// The caseing here needs to match the caseing in the pardot form handler
export const buildToolOptions = [
  { label: 'Gradle', value: 'Gradle' },
  { label: 'Maven', value: 'Maven' },
  { label: 'CMake', value: 'CMake' },
  { label: 'npm', value: 'npm' },
  { label: 'Python', value: 'Python' },
  { label: 'Webpack', value: 'Webpack' },
  { label: 'SBT', value: 'SBT' },
  { label: 'Buck', value: 'Buck' },
  { label: 'Bazel', value: 'Bazel' },
  { label: 'Other', value: 'Other' },
];
